import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { AuthService } from '@core/auth.service'
import { HasLicenceGuard, HasNoLicenceGuard } from '@core/licence.guard.service'
import { AccessDeniedComponent } from './page/public/access-denied/access-denied.component'

const routes: Routes = [
   {
      path: '',
      redirectTo: '/dashboard',
      pathMatch: 'full',
   },
   {
      path: 'dashboard',
      loadChildren: () => import('./page/private/dashboard/dashboard-page.module').then((mod) => mod.DashboardPageModule),
      canActivate: [AuthService, HasLicenceGuard],
   },
   {
      path: 'sectors',
      loadChildren: () => import('./page/private/prefiltered/prefiltered-page.module').then((mod) => mod.PrefilteredPageModule),
      canActivate: [AuthService, HasLicenceGuard],
   },
   {
      path: 'services',
      loadChildren: () => import('./page/private/prefiltered/prefiltered-page.module').then((mod) => mod.PrefilteredPageModule),
      canActivate: [AuthService, HasLicenceGuard],
   },
   {
      path: 'grants',
      loadChildren: () => import('./page/private/prefiltered/prefiltered-page.module').then((mod) => mod.PrefilteredPageModule),
      canActivate: [AuthService, HasLicenceGuard],
   },
   {
      path: 'account',
      loadChildren: () => import('./page/private/account-profile/account-profile-page.module').then((mod) => mod.AccountProfilePageModule),
      canActivate: [AuthService, HasLicenceGuard],
   },
   { path: 'access-denied', component: AccessDeniedComponent, canActivate: [AuthService, HasNoLicenceGuard] },
   { path: '**', redirectTo: '/dashboard' },
]

@NgModule({
   imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
   exports: [RouterModule],
   providers: [AuthService, HasLicenceGuard],
})
export class AppRoutingModule {}

